<div class="" style="width: 100%; display: flex; height: 100vh">
  <!-- Left section - Desktop only -->
  <div class="left-section">
    <div class="left-content">
      <div class="left-text">
        <div class="logo-container">
          <img
            src="/assets/images/logo/MealCheckWhite.webp"
            alt="Logo MealCheck"
            class="logo"
          />
        </div>
        <p class="slogan">Un effectif bien saisi, un service bien servi.</p>
      </div>
    </div>
    <img
      src="/assets/images/representations/two_persons.png"
      alt="Illustration de deux personnes"
      class="left-illustration"
    />
  </div>

  <!-- Right section - Form -->
  <div class="right-section">
    <div class="form-container">
      <!-- Mobile logo -->
      <div class="mobile-logo">
        <img
          src="/assets/images/logo/MealCheckBlack.webp"
          alt="Logo MealCheck"
          class="logo"
        />
      </div>

      <!-- Form header -->
      <div class="form-header">
        <h1>Connexion</h1>
        <p>
          Connectez-vous à votre compte pour gérer les effectifs de vos
          établissements !
        </p>
      </div>

      <div class="form-group">
        <label for="email">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            style="
              width: 16px;
              height: 16px;
              display: inline-block;
              margin-right: 6px;
              vertical-align: middle;
            "
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
            ></path>
          </svg>
          Adresse e-mail ou login
        </label>
        <div class="input-container">
          <input
            type="text"
            id="email"
            name="email"
            autocomplete="email"
            required
            placeholder="votre@email.com"
            class="text-black w-full !px-4 !py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
            [class.border-red-500]="invalidEmail"
            [class.focus:ring-red-500]="invalidEmail"
            [class.focus:border-red-500]="invalidEmail"
            [disabled]="working"
            [(ngModel)]="email"
          />
        </div>
      </div>

      <div class="form-group">
        <label for="password">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            style="
              width: 16px;
              height: 16px;
              display: inline-block;
              margin-right: 6px;
              vertical-align: middle;
            "
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
            ></path>
          </svg>
          Mot de passe
        </label>
        <div class="input-container">
          <input
            type="password"
            id="password"
            name="password"
            autocomplete="current-password"
            required
            placeholder="••••••••"
            class="text-black w-full !px-4 !py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
            [class.border-red-500]="invalidPassword"
            [class.focus:ring-red-500]="invalidPassword"
            [class.focus:border-red-500]="invalidPassword"
            [disabled]="working"
            [(ngModel)]="password"
            (keydown.enter)="login()"
          />
        </div>
      </div>

      <div class="form-group">
        <button
          type="button"
          (click)="login()"
          [disabled]="working"
          class="w-full flex justify-center items-center gap-3 !py-3 !px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-vert-1 hover:bg-vert-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
          [class.bg-emerald-700]="working"
          aria-label="Se connecter"
        >
          <span
            class="material-icons transition-transform duration-500"
            [class.animate-spin]="rotating"
            [innerHTML]="statusIcon"
          ></span>
          <span [innerHTML]="statusLabel"></span>
        </button>
      </div>

      <div class="form-links">
        <a class="reset-password" routerLink="/reset-password/request"
          >Mot de passe oublié ? Réinitialisez le !</a
        >
      </div>
    </div>
  </div>
</div>
